var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6071 18.746C19.6071 19.627 18.8911 20.37 18.0101 20.37H5.23109C4.35009 20.37 3.63409 19.627 3.63409 18.746V5.96703C3.63409 5.08603 4.35009 4.39603 5.23109 4.39603H12.6851V3.33203H5.23109C3.76309 3.33203 2.56909 4.50003 2.56909 5.96803V18.746C2.56909 20.214 3.76309 21.434 5.23109 21.434H18.0091C19.4771 21.434 20.6711 20.213 20.6711 18.746V11.318H19.6061L19.6071 18.746Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8071 3.17016C20.0031 2.36516 18.6001 2.36516 17.7951 3.17016L10.6521 10.3132C10.5841 10.3812 10.5351 10.4672 10.5121 10.5602L9.76012 13.5712C9.71512 13.7522 9.76812 13.9442 9.90012 14.0772C10.0011 14.1782 10.1371 14.2332 10.2761 14.2332C10.3191 14.2332 10.3621 14.2282 10.4051 14.2172L13.4171 13.4642C13.5111 13.4412 13.5961 13.3922 13.6641 13.3242L20.8071 6.18116C21.2091 5.77916 21.4311 5.24416 21.4311 4.67516C21.4311 4.10616 21.2101 3.57216 20.8071 3.17016ZM13.0161 12.4672L11.0081 12.9692L11.5101 10.9612L17.4191 5.05216L18.9251 6.55816L13.0161 12.4672ZM20.0541 5.42816L19.6781 5.80416L18.1721 4.29816L18.5481 3.92216C18.9501 3.52016 19.6521 3.52016 20.0541 3.92216C20.2551 4.12316 20.3661 4.39016 20.3661 4.67516C20.3661 4.96016 20.2551 5.22716 20.0541 5.42816Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.3150e0468670853cfc2491091abf4e81.svg";
export { ForwardRef as ReactComponent };